import script from "./FormularioEntrada.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioEntrada.vue?vue&type=script&setup=true&lang=js"

import "./FormularioEntrada.vue?vue&type=style&index=0&id=5cf19f42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf19f42"]])

export default __exports__